"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.string.small.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.parse-int.js");

var _input = _interopRequireDefault(require("element-ui/lib/input"));

var _option = _interopRequireDefault(require("element-ui/lib/option"));

var _select = _interopRequireDefault(require("element-ui/lib/select"));

var _locale = _interopRequireDefault(require("element-ui/lib/mixins/locale"));

var _util = require("element-ui/lib/utils/util");

var _pager = _interopRequireDefault(require("./pager.js"));

var _default2 = {
  name: 'ElPagination',
  props: {
    pageSize: {
      type: Number,
      "default": 10
    },
    small: Boolean,
    total: Number,
    pageCount: Number,
    pagerCount: {
      type: Number,
      validator: function validator(value) {
        return (value | 0) === value && value > 4 && value < 22 && value % 2 === 1;
      },
      "default": 7
    },
    currentPage: {
      type: Number,
      "default": 1
    },
    layout: {
      "default": 'prev, pager, next, jumper, ->, total'
    },
    pageSizes: {
      type: Array,
      "default": function _default() {
        return [10, 20, 30, 40, 50, 100];
      }
    },
    popperClass: String,
    prevText: String,
    nextText: String,
    background: Boolean,
    disabled: Boolean,
    // 扩展 新增 简单每页显示条数 的开关
    simpleSizes: Boolean
  },
  data: function data() {
    return {
      internalCurrentPage: 1,
      internalPageSize: 0,
      lastEmittedPage: -1,
      userChangePageSize: false
    };
  },
  render: function render(h) {
    var _vm = this;

    var template = h("div", {
      "class": ['el-pagination', {
        'is-background': this.background,
        'el-pagination--small': this.small,
        'is-simple': this.isSimplePage
      }]
    });
    var layout = this.layout || '';
    if (!layout) return;
    var TEMPLATE_MAP = {
      prev: h("prev"),
      jumper: h("jumper"),
      pager: h("pager", {
        "attrs": {
          "currentPage": this.internalCurrentPage,
          "pageCount": this.internalPageCount,
          "pagerCount": this.pagerCount,
          "disabled": this.disabled
        },
        "on": {
          "change": this.handleCurrentChange
        }
      }),
      next: h("next"),
      // 扩展 新增 简单每页显示条数 的开关
      sizes: h("sizes", {
        "attrs": {
          "pageSizes": this.pageSizes,
          "simpleSizes": this.simpleSizes
        }
      }),
      slot: h("my-slot"),
      total: h("total"),
      // 扩展 新增 简单分页 组件
      sp: h("simple-pager")
    };
    var components = layout.split(',').map(function (item) {
      return item.trim();
    });
    var rightWrapper = h("div", {
      "class": "el-pagination__rightwrapper"
    });
    var haveRightWrapper = false;
    template.children = template.children || [];
    rightWrapper.children = rightWrapper.children || [];
    components.forEach(function (compo) {
      if (compo === '->') {
        haveRightWrapper = true;
        return;
      }

      if (!haveRightWrapper) {
        template.children.push(TEMPLATE_MAP[compo]);
      } else {
        rightWrapper.children.push(TEMPLATE_MAP[compo]);
      }
    });

    if (haveRightWrapper) {
      template.children.unshift(rightWrapper);
    }

    return template;
  },
  components: {
    // 扩展 新增 简单分页 组件，如 1/50
    SimplePager: {
      render: function render(h) {
        var _vm = this;

        return h("span", {
          "class": "span-simple-pager"
        }, [this.$parent.internalCurrentPage, " / ", this.$parent.internalPageCount]);
      }
    },
    MySlot: {
      render: function render(h) {
        return this.$parent.$slots["default"] ? this.$parent.$slots["default"][0] : '';
      }
    },
    Prev: {
      render: function render(h) {
        var _vm = this;

        // 扩展
        return h("button", {
          "attrs": {
            "type": "button",
            "disabled": this.$parent.disabled || this.$parent.internalCurrentPage <= 1
          },
          "class": "btn-prev",
          "on": {
            "click": this.$parent.prev
          }
        }, [this.$parent.prevText ? h("span", [this.$parent.prevText]) : h("i", {
          "class": "el-icon el-icon-arrow-left"
        })]);
      }
    },
    Next: {
      render: function render(h) {
        var _vm = this;

        return h("button", {
          "attrs": {
            "type": "button",
            "disabled": this.$parent.disabled || this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0
          },
          "class": "btn-next",
          "on": {
            "click": this.$parent.next
          }
        }, [this.$parent.nextText ? h("span", [this.$parent.nextText]) : h("i", {
          "class": "el-icon el-icon-arrow-right"
        })]);
      }
    },
    Sizes: {
      mixins: [_locale["default"]],
      props: {
        pageSizes: Array,
        // 扩展 新增 简单每页显示条数 的开关
        simpleSizes: Boolean
      },
      watch: {
        pageSizes: {
          immediate: true,
          handler: function handler(newVal, oldVal) {
            if ((0, _util.valueEquals)(newVal, oldVal)) return;

            if (Array.isArray(newVal)) {
              this.$parent.internalPageSize = newVal.indexOf(this.$parent.pageSize) > -1 ? this.$parent.pageSize : this.pageSizes[0];
            }
          }
        }
      },
      // 扩展 计算组件的宽度
      computed: {
        style: function style() {
          return {
            width: this.simpleSizes ? '64px' : '100px'
          };
        }
      },
      render: function render(h) {
        var _this = this;

        var _vm = this;

        return h("span", {
          "class": "el-pagination__sizes"
        }, [h("el-select", (0, _babelHelperVueJsxMergeProps["default"])([{
          "attrs": {
            "value": this.$parent.internalPageSize,
            "popperClass": this.$parent.popperClass || '',
            "size": "mini",
            "disabled": this.$parent.disabled
          },
          "on": {
            "input": this.handleChange
          }
        }, {
          style: _vm._px2rem(this.style, 24, [])
        }]), [this.pageSizes.map(function (item) {
          return h("el-option", {
            "attrs": {
              "value": item,
              "label": item + (_this.simpleSizes ? '' : _this.t('el.pagination.pagesize'))
            }
          });
        })])]);
      },
      components: {
        ElSelect: _select["default"],
        ElOption: _option["default"]
      },
      methods: {
        handleChange: function handleChange(val) {
          if (val !== this.$parent.internalPageSize) {
            this.$parent.internalPageSize = val = parseInt(val, 10);
            this.$parent.userChangePageSize = true;
            this.$parent.$emit('size-change', val);
            this.$parent.$emit('update:pageSize', val);
          }
        }
      }
    },
    Jumper: {
      mixins: [_locale["default"]],
      data: function data() {
        return {
          oldValue: null
        };
      },
      components: {
        ElInput: _input["default"]
      },
      watch: {
        '$parent.internalPageSize': function $parentInternalPageSize() {
          var _this2 = this;

          this.$nextTick(function () {
            _this2.$refs.input.$el.querySelector('input').value = _this2.$parent.internalCurrentPage;
          });
        }
      },
      methods: {
        handleFocus: function handleFocus(event) {
          this.oldValue = event.target.value;
        },
        handleBlur: function handleBlur(_ref) {
          var target = _ref.target;
          this.resetValueIfNeed(target.value);
          this.reassignMaxValue(target.value);
        },
        handleKeyup: function handleKeyup(_ref2) {
          var keyCode = _ref2.keyCode,
              target = _ref2.target;

          if (keyCode === 13 && this.oldValue && target.value !== this.oldValue) {
            this.handleChange(target.value);
          }
        },
        handleChange: function handleChange(value) {
          this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(value);
          this.$parent.emitChange();
          this.oldValue = null;
          this.resetValueIfNeed(value);
        },
        resetValueIfNeed: function resetValueIfNeed(value) {
          var num = parseInt(value, 10);

          if (!isNaN(num)) {
            if (num < 1) {
              this.$refs.input.setCurrentValue(1);
            } else {
              this.reassignMaxValue(value);
            }
          }
        },
        reassignMaxValue: function reassignMaxValue(value) {
          var internalPageCount = this.$parent.internalPageCount;

          if (+value > internalPageCount) {
            this.$refs.input.setCurrentValue(internalPageCount);
          }
        }
      },
      render: function render(h) {
        var _vm = this;

        return h("span", {
          "class": "el-pagination__jump"
        }, [this.t('el.pagination.goto'), h("el-input", {
          "class": "el-pagination__editor is-in-pagination",
          "attrs": {
            "min": 1,
            "max": this.$parent.internalPageCount,
            "value": this.$parent.internalCurrentPage,
            "type": "number",
            "disabled": this.$parent.disabled
          },
          "domProps": {
            "value": this.$parent.internalCurrentPage
          },
          "ref": "input",
          "nativeOn": {
            "keyup": this.handleKeyup
          },
          "on": {
            "change": this.handleChange,
            "focus": this.handleFocus,
            "blur": this.handleBlur
          }
        }), this.t('el.pagination.pageClassifier')]);
      }
    },
    Total: {
      mixins: [_locale["default"]],
      render: function render(h) {
        var _vm = this;

        return typeof this.$parent.total === 'number' ? h("span", {
          "class": "el-pagination__total"
        }, [this.t('el.pagination.total', {
          total: this.$parent.total
        })]) : '';
      }
    },
    Pager: _pager["default"]
  },
  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.internalCurrentPage = this.getValidCurrentPage(val);
      this.userChangePageSize = true;
      this.emitChange();
    },
    prev: function prev() {
      if (this.disabled) return;
      var newVal = this.internalCurrentPage - 1;
      this.internalCurrentPage = this.getValidCurrentPage(newVal);
      this.$emit('prev-click', this.internalCurrentPage);
      this.emitChange();
    },
    next: function next() {
      if (this.disabled) return;
      var newVal = this.internalCurrentPage + 1;
      this.internalCurrentPage = this.getValidCurrentPage(newVal);
      this.$emit('next-click', this.internalCurrentPage);
      this.emitChange();
    },
    getValidCurrentPage: function getValidCurrentPage(value) {
      value = parseInt(value, 10);
      var havePageCount = typeof this.internalPageCount === 'number';
      var resetValue;

      if (!havePageCount) {
        if (isNaN(value) || value < 1) resetValue = 1;
      } else {
        if (value < 1) {
          resetValue = 1;
        } else if (value > this.internalPageCount) {
          resetValue = this.internalPageCount;
        }
      }

      if (resetValue === undefined && isNaN(value)) {
        resetValue = 1;
      } else if (resetValue === 0) {
        resetValue = 1;
      }

      return resetValue === undefined ? value : resetValue;
    },
    emitChange: function emitChange() {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.internalCurrentPage !== _this3.lastEmittedPage || _this3.userChangePageSize) {
          _this3.$emit('current-change', _this3.internalCurrentPage);

          _this3.lastEmittedPage = _this3.internalCurrentPage;
          _this3.userChangePageSize = false;
        }
      });
    }
  },
  computed: {
    internalPageCount: function internalPageCount() {
      if (typeof this.total === 'number') {
        /** 扩展 无数据时，当前页数固定为1 */
        if (this.total <= 0) {
          return 1;
        }

        return Math.ceil(this.total / this.internalPageSize);
      } else if (typeof this.pageCount === 'number') {
        return this.pageCount;
      }

      return null;
    },
    // 扩展
    isSimplePage: function isSimplePage() {
      return this.layout.indexOf('sp') > 0;
    }
  },
  watch: {
    currentPage: {
      immediate: true,
      handler: function handler(val) {
        this.internalCurrentPage = val;
      }
    },
    pageSize: {
      immediate: true,
      handler: function handler(val) {
        this.internalPageSize = isNaN(val) ? 10 : val;
      }
    },
    internalCurrentPage: {
      immediate: true,
      handler: function handler(newVal, oldVal) {
        newVal = parseInt(newVal, 10);
        /* istanbul ignore if */

        if (isNaN(newVal)) {
          newVal = oldVal || 1;
        } else {
          newVal = this.getValidCurrentPage(newVal);
        }

        if (newVal !== undefined) {
          this.internalCurrentPage = newVal;

          if (oldVal !== newVal) {
            this.$emit('update:currentPage', newVal, oldVal);
          }
        } else {
          this.$emit('update:currentPage', newVal, oldVal);
        }

        this.lastEmittedPage = -1;
      }
    },
    internalPageCount: function internalPageCount(newVal) {
      /* istanbul ignore if */
      var oldPage = this.internalCurrentPage;

      if (newVal > 0 && oldPage === 0) {
        this.internalCurrentPage = 1;
      } else if (oldPage > newVal) {
        this.internalCurrentPage = newVal === 0 ? 1 : newVal;
        this.userChangePageSize && this.emitChange();
      }

      this.userChangePageSize = false;
    }
  }
};
exports["default"] = _default2;